(function () {
  function init() {
    var wrapper = document.querySelector('[li-element="mini-cart"]');
    var toggle  = document.querySelector('[li-element="mini-cart-toggle"]');
    var drawer  = document.querySelector('[li-element="mini-cart-container"]');
    if (!wrapper || !toggle || !drawer) return;

    function closeButton() {
      var buttons = drawer.querySelectorAll('.nav_dropdown-close-button');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].offsetParent !== null) return buttons[i];
      }
      return null;
    }

    var wasOpen = drawer.classList.contains('w--open');

    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('w--open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;

      if (isOpen) {
        setTimeout(function () {
          var target = closeButton() || drawer;
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus();
        }, 150);
      } else if (wrapper.contains(document.activeElement) ||
                 document.activeElement === document.body) {
        toggle.focus();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!drawer.classList.contains('w--open')) return;
      setTimeout(function () {
        if (!drawer.classList.contains('w--open')) return;
        var btn = closeButton();
        if (btn) btn.click();
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function initFilterPanel() {
    var btn   = document.querySelector('.filter_tablet-filters-button');
    var panel = document.getElementById('filter-panel');
    if (!btn || !panel) return;

    var close = document.querySelector('.filter_tablet-modal-close-button');

    function isOpen() {
      var m = getComputedStyle(panel).transform;
      if (!m || m === 'none') return true;
      var parts = m.match(/matrix\(([^)]+)\)/);
      if (!parts) return true;
      var translateY = parseFloat(parts[1].split(',')[5]);
      return Math.abs(translateY) < 5;
    }

    function sync() {
      var open = isOpen();
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return open;
    }

    var wasOpen = sync();

    new MutationObserver(function () {
      var open = sync();
      if (open === wasOpen) return;
      wasOpen = open;

      if (open && close) {
        setTimeout(function () { close.focus(); }, 350);
      } else if (!open && panel.contains(document.activeElement)) {
        btn.focus();
      }
    }).observe(panel, { attributes: true, attributeFilter: ['style'] });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!isOpen() || !close) return;
      if (btn.offsetParent === null) return;
      close.click();
    });

    // These controls sit outside any Alpine x-data scope, so x-on: attributes
    // on them never initialize. Space has to be wired up here instead.
    function activateOnSpace(el) {
      if (!el) return;
      el.addEventListener('keydown', function (e) {
        if (e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        el.click();
      });
    }

    activateOnSpace(btn);
    activateOnSpace(close);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterPanel);
  } else {
    initFilterPanel();
  }
})();

(function () {
  function initAddressModals() {
    var dialogs = document.querySelectorAll('.addresses_modal');
    if (!dialogs.length) return;

    function onKeys(el, keys, handler) {
      el.addEventListener('keydown', function (e) {
        if (keys.indexOf(e.key) === -1) return;
        e.preventDefault();
        handler();
      });
    }

    // Edit / Cancel triggers. Anchors driven by Alpine click bindings, so they
    // already have names from their text; they just lack button semantics.
    var triggers = document.querySelectorAll('a[href="#"][aria-controls^="modal-"]');
    Array.prototype.forEach.call(triggers, function (a) {
      a.setAttribute('role', 'button');
      onKeys(a, [' ', 'Spacebar'], function () { a.click(); });
    });

    // The dismiss control is an empty div: no name, no role, and not focusable.
    var closers = document.querySelectorAll('.addresses_modal-close');
    Array.prototype.forEach.call(closers, function (el) {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Close address form');
      }
      // A div has no native activation, so Enter needs handling too.
      onKeys(el, ['Enter', ' ', 'Spacebar'], function () { el.click(); });
    });

    // The markup's own Escape binding assigns to `open`, but the state variable
    // is `modal`, so it never closes anything. Activate the visible dialog's
    // close control instead, which carries the correct binding.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      for (var i = 0; i < dialogs.length; i++) {
        var open = dialogs[i].getAttribute('aria-hidden') === 'false' ||
                   dialogs[i].offsetParent !== null;
        if (!open) continue;
        var btn = dialogs[i].querySelector('.addresses_modal-close');
        if (btn) btn.click();
        return;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddressModals);
  } else {
    initAddressModals();
  }
})();

/* --------------------------------------------------------------------------
   A11Y-009 — Form status messages are announced (WCAG 4.1.3, AA)

   Both forms post natively to /contact and the page reloads: Webflow's AJAX
   handler bails whenever a form carries a real `action`, so the .w-form-done /
   .w-form-fail divs in the section markup are never toggled — they are dead.
   The real messages come from Liquid instead:

     "Get in Touch"  ({% form 'contact' %}, sections/gleezy_contact.liquid)
       renders .form-message-wrapper inside the <form> for BOTH outcomes. The
       success and error blocks are identical apart from their copy, so only
       the ?contact_posted flag distinguishes them.

     "Sign up to stay sauced" ({% form 'customer' %}, sections/footer.liquid)
       renders nothing for either outcome, so every message here is ours.

   A live region that already holds its text at page load announces nothing —
   on a reload the whole document is new. So the regions are created empty and
   written to afterwards. Where a message is on screen it also takes focus,
   which is the dependable way to confirm a post-reload submit to a screen
   reader; focus is used *instead of* the live region so nothing double-speaks.
   -------------------------------------------------------------------------- */
(function () {
  var INJECT_VISIBLE_MESSAGES = true;  // draw a message where the theme renders none
  var MOVE_FOCUS_TO_MESSAGE   = true;  // send focus to the confirmation on load

  var SUCCESS_TEXT = 'Thank you! Your submission has been received!';
  var ERROR_TEXT   = 'Oops! Something went wrong while submitting the form.';
  var PENDING_KEY  = 'gleezy-form-pending';
  var PENDING_TTL  = 60000;

  var polite, assertive;

  function offscreen(el) {
    el.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;' +
      'padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);' +
      'white-space:nowrap;border:0';
  }

  function liveRegion(role, live) {
    var el = document.createElement('div');
    el.setAttribute('role', role);
    el.setAttribute('aria-live', live);
    el.setAttribute('aria-atomic', 'true');
    offscreen(el);
    document.body.appendChild(el);
    return el;
  }

  // Region exists first, text lands second — that gap is what makes it speak.
  function announce(region, text) {
    if (!region) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = text; }, 150);
  }

  // Both forms carry id="contact_form", so look them up by form_type instead.
  function formOfType(type) {
    var input = document.querySelector('input[name="form_type"][value="' + type + '"]');
    return input ? input.closest('form') : null;
  }

  function renderedMessage(form) {
    if (!form) return null;
    var el = form.querySelector('.form-message-wrapper');
    return el && el.offsetParent !== null && el.textContent.trim() ? el : null;
  }

  // Build the theme's own message chip after a form that renders none. Success
  // and failure share one treatment on purpose — the brand addendum asks that
  // no signal ride on color alone, so the wording is what separates them. The
  // data attribute is a styling hook if a distinct look is wanted later.
  function injectMessage(form, text, kind) {
    if (!form || !INJECT_VISIBLE_MESSAGES) return null;

    var existing = form.parentNode.querySelector('[data-a11y-form-message]');
    if (existing) return existing;

    var wrapper = document.createElement('div');
    wrapper.className = 'form-message-wrapper';
    wrapper.setAttribute('data-a11y-form-message', kind);

    var chip = document.createElement('div');
    chip.className = 'form-message';
    chip.textContent = text;

    wrapper.appendChild(chip);
    form.parentNode.insertBefore(wrapper, form.nextSibling);
    return wrapper;
  }

  function present(el, role, text, region) {
    if (el) {
      el.setAttribute('role', role);
      if (MOVE_FOCUS_TO_MESSAGE) {
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        setTimeout(function () { el.focus(); }, 0);
        return;
      }
    }
    announce(region, text);
  }

  function markPending(type) {
    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({ type: type, t: Date.now() }));
    } catch (e) {}
  }

  // Read once and clear, so a stale flag can't mis-report a later page view.
  function takePending() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(PENDING_KEY);
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      return (Date.now() - data.t) < PENDING_TTL ? data : null;
    } catch (e) {}
    return null;
  }

  function report(contactForm, newsletterForm) {
    var params  = new URLSearchParams(window.location.search);
    var pending = takePending();
    var served  = renderedMessage(contactForm);

    // Success and error use the same markup, so the flag decides which it is.
    if (params.has('contact_posted')) {
      present(served || injectMessage(contactForm, SUCCESS_TEXT, 'success'),
              'status', SUCCESS_TEXT, polite);
      return;
    }

    // Rendered but not flagged as posted: this is the {% if form.errors %} block.
    if (served) {
      present(served, 'alert', served.textContent.trim(), assertive);
      return;
    }

    if (params.has('customer_posted')) {
      present(injectMessage(newsletterForm, SUCCESS_TEXT, 'success'),
              'status', SUCCESS_TEXT, polite);
      return;
    }

    // Nothing flagged, nothing rendered, but a submit did leave this session:
    // the post-back failed. (`submit` only fires once validation has passed.)
    if (pending) {
      var form = pending.type === 'contact' ? contactForm : newsletterForm;
      present(injectMessage(form, ERROR_TEXT, 'error'), 'alert', ERROR_TEXT, assertive);
    }
  }

  function init() {
    var contactForm    = formOfType('contact');
    var newsletterForm = formOfType('customer');
    if (!contactForm && !newsletterForm) return;

    polite    = liveRegion('status', 'polite');
    assertive = liveRegion('alert', 'assertive');

    if (contactForm) {
      contactForm.addEventListener('submit', function () { markPending('contact'); });
    }
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function () { markPending('customer'); });
    }

    // Let the screen reader finish reading the freshly loaded page first.
    setTimeout(function () { report(contactForm, newsletterForm); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   A11Y-010 — Form fields carry programmatic labels (WCAG 1.3.1, 3.3.2, 4.1.2)

   Audited against the rendered DOM rather than the ticket's assumption. Two
   controls it flagged turned out to be fine already and are left alone:

     #filter-search  — sections/search.liquid ships a real
                       <label for> with class form_hidden-label
     the radios      — Sales / Collaborate / Other sit inside a wrapping
                       <label>, so they name themselves implicitly

   What genuinely has no label is listed below, plus two the ticket did not
   mention: the footer signup arrow is <input type="submit" value=""> with no
   accessible name at all, and the collection/search sort <select> has none
   either. Both are worse than placeholder-only — a placeholder at least
   produces a name, if a fragile one.

   Real <label> elements are used rather than aria-label, per the ticket. The
   theme already ships .form_hidden-label (clip-rect, 1px, absolute) for
   exactly this, and it stays out of flex/grid flow because it is absolute.
   -------------------------------------------------------------------------- */
(function () {
  var HIDDEN_LABELS = [
    { id: 'contact-name',    text: 'Name' },
    { id: 'contact-email',   text: 'Email Address' },
    { id: 'contact-message', text: 'Message' },
    { id: 'email-address-2', text: 'Email address' },
    { id: 'sort-by',         text: 'Sort by' }
  ];

  // A value-less submit input cannot take a <label>, and giving it a value
  // would print text across the arrow graphic — aria-label is correct here.
  var BUTTON_LABELS = [
    { selector: '.footer-form-button', text: 'Sign up' }
  ];

  var INK_DARK  = '#1A0909';  // 15.57:1 on the yellow contact section
  var INK_LIGHT = '#E3DED8';  // ~14.4:1 on the charcoal footer

  function named(field) {
    return !!(field.getAttribute('aria-label') ||
              field.getAttribute('aria-labelledby') ||
              (field.id && document.querySelector('label[for="' + field.id + '"]')) ||
              field.closest('label'));
  }

  function addHiddenLabel(entry) {
    var field = document.getElementById(entry.id);
    if (!field || named(field)) return;
    var label = document.createElement('label');
    label.className = 'form_hidden-label';
    label.setAttribute('for', entry.id);
    label.textContent = entry.text;
    field.parentNode.insertBefore(label, field);
  }

  function addButtonLabel(entry) {
    var btn = document.querySelector(entry.selector);
    if (!btn || named(btn) || (btn.value || '').trim()) return;
    btn.setAttribute('aria-label', entry.text);
  }

  /* ---- validation errors: aria-invalid + aria-describedby ---------------- */

  function formOfType(type) {
    var input = document.querySelector('input[name="form_type"][value="' + type + '"]');
    return input ? input.closest('form') : null;
  }

  // One message per radio group, so all its members share an id and state.
  function errorId(field) {
    var key = field.type === 'radio' ? field.name : (field.id || field.name || 'field');
    return 'a11y-' + key.replace(/[^a-zA-Z0-9_-]/g, '-') + '-error';
  }

  function groupOf(field) {
    if (field.type !== 'radio' || !field.form || !field.name) return [field];
    return Array.prototype.slice.call(
      field.form.querySelectorAll('input[type="radio"][name="' + field.name + '"]'));
  }

  // Keep the message out of flex rows that would lay it out as another column.
  function errorHost(field) {
    return field.closest('.footer-form-field-wrapper, .radio-button-section') || field;
  }

  function relativeLuminance(r, g, b) {
    var c = [r, g, b].map(function (v) {
      v = v / 255;
      return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  // Inheriting would hand us .contact-form-section-1 #a3a3a3, which is 2.03:1
  // on the yellow section. Pick the brand ink that reads on the real backdrop.
  function ink(el) {
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      var m = getComputedStyle(n).backgroundColor.match(/rgba?\(([^)]+)\)/);
      if (!m) continue;
      var p = m[1].split(',').map(parseFloat);
      if (p.length > 3 && p[3] === 0) continue;
      return relativeLuminance(p[0], p[1], p[2]) > 0.18 ? INK_DARK : INK_LIGHT;
    }
    return INK_DARK;
  }

  function describe(field, id, add) {
    var ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var at = ids.indexOf(id);
    if (add && at === -1) ids.push(id);
    if (!add && at !== -1) ids.splice(at, 1);
    if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
    else field.removeAttribute('aria-describedby');
  }

  function showError(field, message) {
    var id = errorId(field);
    var node = document.getElementById(id);
    if (!node) {
      node = document.createElement('div');
      node.id = id;
      node.className = 'form_message-error';
      node.setAttribute('data-a11y-field-error', '');
      node.style.color = ink(field);
      var host = errorHost(field);
      host.parentNode.insertBefore(node, host.nextSibling);
    }
    node.textContent = message;
    groupOf(field).forEach(function (member) {
      member.setAttribute('aria-invalid', 'true');
      describe(member, id, true);
    });
  }

  function clearError(field) {
    var id = errorId(field);
    var node = document.getElementById(id);
    if (node) node.parentNode.removeChild(node);
    groupOf(field).forEach(function (member) {
      member.removeAttribute('aria-invalid');
      describe(member, id, false);
    });
  }

  // validity.valid is read, never checkValidity() — the latter re-fires the
  // invalid event, which would re-enter the handler and steal focus on every
  // keystroke.
  function revalidate(field) {
    if (!field || !field.validity) return;
    if (field.getAttribute('aria-invalid') !== 'true') return;
    if (field.validity.valid) clearError(field);
  }

  function wire(form) {
    if (!form) return;
    var pendingFocus = null;

    form.addEventListener('invalid', function (e) {
      // Suppress the native bubble: it vanishes on a timer, is not tied to the
      // field, and would double up with the message we attach via describedby.
      e.preventDefault();
      var field = e.target;
      showError(field, field.validationMessage);
      if (!pendingFocus) {
        pendingFocus = field;
        setTimeout(function () {
          if (pendingFocus) { pendingFocus.focus(); pendingFocus = null; }
        }, 0);
      }
    }, true);

    form.addEventListener('input',  function (e) { revalidate(e.target); });
    form.addEventListener('change', function (e) { revalidate(e.target); });
  }

  function init() {
    HIDDEN_LABELS.forEach(addHiddenLabel);
    BUTTON_LABELS.forEach(addButtonLabel);
    wire(formOfType('contact'));
    wire(formOfType('customer'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   A11Y-011 — Radio group semantics (WCAG 4.1.2)

   The ticket reads Sales / Collaborate / Other as "category switchers" and
   prescribes ARIA tabs or aria-expanded buttons. They are neither. They are
   <input type="radio" name="contact[Business]"> in the contact form: nothing
   reacts to them, there is no panel to show or hide, and the value is simply
   submitted. Tab or disclosure semantics would misdescribe a form input and
   break the interaction model a radio group already gives users, so the radios
   stay. Arrow-key navigation is native to a same-name radio group and nothing
   intercepts keydown, so it needs no code.

   That left one gap for this file: .radio-button-section carried no role and
   no accessible name, so the group announced as "Sales, radio button, 1 of 3"
   with nothing to say what was being chosen.

   The other half of the ticket — no visible focus — was Webflow's own Focused
   state, styled to box-shadow:none in the Designer. It is now a maroon
   (dog-red #6f0911) outline on .radio-button and .product-header_radio-button,
   9.82:1 on the yellow section and 9.12:1 on the cream body. A JS fallback
   ring used to live here for controls the theme left unstyled; every one of
   them is now covered in the Designer, so it has been removed rather than left
   to compete with the stylesheet.
   -------------------------------------------------------------------------- */
(function () {
  // Only groups that can be named honestly. An unmapped group is left alone.
  var GROUP_LABELS = {
    'contact[Business]': 'Reason for contact'
  };

  function labelGroups() {
    var sections = document.querySelectorAll('.radio-button-section');
    Array.prototype.forEach.call(sections, function (section) {
      var radios = section.querySelectorAll('input[type="radio"]');
      if (radios.length < 2) return;          // a lone radio is not a group
      var name = radios[0].name;
      for (var i = 1; i < radios.length; i++) {
        if (radios[i].name !== name) return;  // mixed section, leave it alone
      }
      var label = GROUP_LABELS[name];
      if (!label || section.getAttribute('role')) return;
      section.setAttribute('role', 'radiogroup');
      section.setAttribute('aria-label', label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelGroups);
  } else {
    labelGroups();
  }
})();

/* --------------------------------------------------------------------------
   Collection filters — expose the applied state (WCAG 1.3.1, 4.1.2)

   Found while reviewing A11Y-011. Each filter is an <a href> whose entire
   state lives in CSS classes:

     <a href="..." class="filter_form_checkbox is-disabled">
       <div class="filter_form_checkbox-icon is-checked"></div>
       <div class="filter_form_checkbox-label">In stock (23)</div>
     </a>

   So "In stock (23), link" is announced whether or not the filter is applied,
   and the greyed-out zero-count options announce as ordinary links. A screen
   reader user cannot tell which filters are on, or which lead nowhere.

   The control looks like a checkbox and toggles like one, so it is given
   checkbox semantics rather than a state bolted onto a link — aria-pressed is
   not valid on a link, and aria-current would leave the unchecked state
   silent. Space is wired up because a role must not be claimed without the
   keys that role implies; Enter keeps working natively.

   aria-disabled only reports what the styling already says. The link stays
   focusable and functional on purpose: discoverable-but-unavailable beats
   removing it from the tab order, and describing the visual state is the point
   here, not changing behaviour.

   Filters navigate the whole page rather than updating in place, so this runs
   once per load and needs no observer.
   -------------------------------------------------------------------------- */
(function () {
  var headingSeq = 0;

  function groupFilters(group) {
    var list = group.querySelector('.filter_list');
    var heading = group.querySelector('.filter_filter-group-heading div');
    if (!list || !heading || list.getAttribute('role')) return;
    if (!heading.id) heading.id = 'a11y-filter-group-' + (++headingSeq);
    list.setAttribute('role', 'group');
    list.setAttribute('aria-labelledby', heading.id);
  }

  function describeOption(link) {
    var icon = link.querySelector('.filter_form_checkbox-icon');
    if (!icon) return;
    link.setAttribute('role', 'checkbox');
    link.setAttribute('aria-checked', icon.classList.contains('is-checked') ? 'true' : 'false');
    if (link.classList.contains('is-disabled')) {
      link.setAttribute('aria-disabled', 'true');
    }
  }

  function init() {
    var links = document.querySelectorAll('a.filter_form_checkbox');
    if (!links.length) return;

    Array.prototype.forEach.call(document.querySelectorAll('.filter_filter-group'), groupFilters);
    Array.prototype.forEach.call(links, describeOption);

    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      var link = e.target && e.target.closest && e.target.closest('a.filter_form_checkbox');
      if (!link) return;
      e.preventDefault();   // a checkbox toggles; it does not scroll the page
      link.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   A11Y-013 — Link names that misdescribe or under-describe their link
   (WCAG 2.4.4, 2.5.3, 4.1.2)

   Audited across nine templates. The repetition the ticket describes is mostly
   not a defect: the "Shop in-store" links already carry a distinguishing
   aria-label, and every copy on a given page points at one destination, which
   2.4.4 permits and 3.2.4 actively wants. Two other things are real.

   1. Labels that lie. Five section templates hardcode an aria-label onto a
      button whose href *and* visible text come from section.settings, so the
      label survives when a merchant repurposes the button:

        "Shop gleezy in-store"              -> "Shop in-store - Opens store locator map page"
        "Tell your local club manager..."   -> "Shop in-store - Opens store locator map page"  (goes to /pages/contact)
        "get in touch to learn more"        -> "Shop Online - Opens gleezy.com online store"
        "Learn more"                        -> "Get In Touch - opens contact page"             (goes to /pages/about)

      These do not merely fail to distinguish, they name the wrong
      destination, and since the visible words are not inside the accessible
      name they break voice control too — "click Learn more" matches nothing
      (2.5.3 Label in Name). Such a label is removed, so the name falls back to
      the visible text, which is accurate by construction. Labels that do
      contain their visible text are kept, as is any icon-only link where the
      label is the only name there is.

   2. Names that survive removal but say nothing out of context. Pulled into a
      screen reader's link list, "Learn more" and "here" identify nothing.
      Each gets visually hidden text appended rather than an aria-label, so the
      visible words stay inside the accessible name and 2.5.3 still holds.

   Not fixed here, because it is a Webflow link setting rather than markup: the
   footer character logo points at "../index.html", which Shopify serves as a
   second copy of the homepage. With the header logo on "/", two links named
   "Gleezy - Home" lead to different URLs. It is only visible at >=992px, since
   .footer-graphic-wrapper is display:none below that.

   October 2026: visibleText() now ignores the contents of <svg>, <style>,
   <script> and <template>. The Swiper arrows embed an SVG whose <style> block
   (".d { fill: #6f0911 }") is text content but is never rendered. It was read
   as visible text, did not match "Previous slide" / "Next slide", and so the
   icon-only arrows lost the only name they had — the axe link-name failure
   on all 23 product pages.
   -------------------------------------------------------------------------- */
(function () {
  // Verified pairings only — matched on both the visible words and the
  // destination, so a repurposed button never picks up the wrong context.
  var CONTEXT = [
    { text: 'learn more', href: '/pages/about',           add: ' about Gleezy' },
    { text: 'here',       href: '/collections/shop-all',  add: ': shop all merchandise' }
  ];

  // Compare with whitespace and case removed: the header's visible text renders
  // as "Shop" and "in-store" in separate elements and should still count as
  // contained in "Shop in-store - Opens store locator map page".
  function squash(value) {
    return (value || '').replace(/\s+/g, '').toLowerCase();
  }

  function visibleText(link) {
    var clone = link.cloneNode(true);
    // Inline SVG markup carries text content (a <style> block, a <title>) that
    // is never painted as text, so it cannot count as a visible label.
    var hidden = clone.querySelectorAll(
      '[aria-hidden="true"], .form_hidden-label, svg, style, script, template');
    for (var i = 0; i < hidden.length; i++) {
      if (hidden[i].parentNode) hidden[i].parentNode.removeChild(hidden[i]);
    }
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function dropMisleadingLabel(link) {
    var text = visibleText(link);
    if (!text) return;   // icon-only: the label is the only name it has

    var label = link.getAttribute('aria-label');
    if (squash(label).indexOf(squash(text)) !== -1) return;

    link.removeAttribute('aria-label');
    link.setAttribute('data-a11y-label-removed', label);
  }

  function addContext(link) {
    if (link.getAttribute('aria-label')) return;          // already named explicitly
    if (link.querySelector('.form_hidden-label')) return; // already extended
    var text = squash(visibleText(link));
    var href = link.getAttribute('href') || '';

    for (var i = 0; i < CONTEXT.length; i++) {
      var rule = CONTEXT[i];
      if (text !== squash(rule.text)) continue;
      if (href.split('?')[0] !== rule.href) continue;
      var span = document.createElement('span');
      span.className = 'form_hidden-label';
      span.textContent = rule.add;
      link.appendChild(span);
      return;
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('a[aria-label]'), dropMisleadingLabel);
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), addContext);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   A11Y-016 — Visible focus indicators (WCAG 2.4.7, 1.4.11)

   Verified: nothing in the site stylesheet suppresses outlines, so most links
   keep the browser's own adaptive ring. Webflow's base stylesheet is the
   problem, and it cannot be edited in the Designer:

     .w-input:focus, .w-select:focus { border-color:#3898EC; outline:0 }
     .w-dropdown-toggle:focus        { outline:0 }
     .w-slider-arrow-left:focus, .w-slider-arrow-right:focus { outline:0 }

   The input rule swaps the outline for a blue border, which the theme's own
   border styling then overrides, so text fields, textareas and selects end up
   with no focus indicator at all. Confirmed live: #contact-name and
   #email-address-2 both compute to outline:none 0px on focus, as does the
   mobile menu button.

   This measures what the stylesheet actually renders and only steps in when
   that falls short of the 3:1 a non-text indicator needs, so styling any of
   these properly in Webflow retires the fallback for that control. An
   outline-style of "auto" is left alone: that is the browser's own two-tone
   ring, which adapts to its backdrop and cannot be judged from a computed
   colour.

   Ring colour follows the backdrop rather than a fixed value — maroon reads at
   9.82:1 on the yellow section and 9.12:1 on the cream body, but only 1.59:1
   on the charcoal footer, where cream is used instead.
   -------------------------------------------------------------------------- */
(function () {
  var INK_DARK  = '#6F0911';   // dog-red, matching the radio focus ring
  var INK_LIGHT = '#E3DED8';
  var MIN_CONTRAST = 3;

  function relativeLuminance(r, g, b) {
    var c = [r, g, b].map(function (v) {
      v = v / 255;
      return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  function contrast(a, b) {
    var hi = Math.max(a, b), lo = Math.min(a, b);
    return (hi + 0.05) / (lo + 0.05);
  }

  function parseColor(value) {
    var m = value && value.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    if (p.length > 3 && p[3] === 0) return null;
    return p;
  }

  function backdrop(el) {
    for (var n = el.parentElement; n && n !== document.documentElement; n = n.parentElement) {
      var p = parseColor(getComputedStyle(n).backgroundColor);
      if (p) return relativeLuminance(p[0], p[1], p[2]);
    }
    return 1;
  }

  function alreadyVisible(el) {
    var cs = getComputedStyle(el);
    if (cs.outlineStyle === 'auto') return true;   // the browser's own ring

    var colour = null;
    if (cs.outlineStyle !== 'none' && parseFloat(cs.outlineWidth) > 0) {
      colour = parseColor(cs.outlineColor);
    }
    if (!colour && cs.boxShadow && cs.boxShadow !== 'none') {
      colour = parseColor(cs.boxShadow);
    }
    if (!colour) return false;

    return contrast(relativeLuminance(colour[0], colour[1], colour[2]),
                    backdrop(el)) >= MIN_CONTRAST;
  }

  function keyboardFocus(el) {
    try { return el.matches(':focus-visible'); }
    catch (e) { return true; }
  }

  function init() {
    document.addEventListener('focusin', function (e) {
      var el = e.target;
      if (!el || !el.style || !keyboardFocus(el)) return;
      // Let any stylesheet rule settle before judging what it drew.
      setTimeout(function () {
        if (alreadyVisible(el)) return;
        el.style.outline = '2px solid ' + (backdrop(el) > 0.18 ? INK_DARK : INK_LIGHT);
        el.style.outlineOffset = '2px';
        el.setAttribute('data-a11y-focus-ring', '');
      }, 0);
    });

    document.addEventListener('focusout', function (e) {
      var el = e.target;
      if (!el || !el.hasAttribute || !el.hasAttribute('data-a11y-focus-ring')) return;
      el.style.outline = '';
      el.style.outlineOffset = '';
      el.removeAttribute('data-a11y-focus-ring');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   Disclosure state on nav and dropdown toggles (WCAG 4.1.2)

   The mobile menu button carries aria-expanded but never updates it: opening
   the menu adds w--open and sets the panel to display:block while the button
   still reports aria-expanded="false", so a screen reader is told the menu is
   collapsed while it is on screen.

   Webflow already tracks open state in the w--open class, so this mirrors that
   class onto aria-expanded for every nav and dropdown toggle. Where Webflow
   does maintain the attribute, writing the same value is a no-op.
   -------------------------------------------------------------------------- */
(function () {
  function sync(toggle) {
    var open = toggle.className.indexOf('w--open') !== -1;
    var want = open ? 'true' : 'false';
    if (toggle.getAttribute('aria-expanded') !== want) {
      toggle.setAttribute('aria-expanded', want);
    }
  }

  function init() {
    var toggles = document.querySelectorAll('.w-nav-button, .w-dropdown-toggle');
    if (!toggles.length) return;

    Array.prototype.forEach.call(toggles, function (toggle) {
      sync(toggle);
      new MutationObserver(function () { sync(toggle); })
        .observe(toggle, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   A11Y-017 — Redundant tab stops in the Instagram section (WCAG 2.4.3)

   The section spends five tab stops on one destination: a "Join Our Community"
   call to action plus four photo tiles, all pointing at the same profile URL.
   The first keeps its place in the tab order and the rest are taken out of it.
   They stay in the accessibility tree with their alt text intact, so a screen
   reader can still reach and activate them in browse mode — only the
   keyboard-only cost drops, from five stops to one.

   The distributor marquee looked like the same defect and is not: its eleven
   logos are tripled for the scroll effect, but the clones already carry both
   aria-hidden="true" and tabindex="-1", so only the eleven real links are in
   the tab order. Checking that with .focus() is what made it look broken —
   focus() succeeds on a tabindex="-1" element, so it measures focusability,
   never tab order.
   -------------------------------------------------------------------------- */
(function () {
  function removeFromTabOrder(el) {
    if (el.getAttribute('tabindex') === '-1') return;
    el.setAttribute('tabindex', '-1');
    el.setAttribute('data-a11y-untabbed', '');
  }

  function init() {
    var section = document.querySelector('.social-feed');
    if (!section) return;
    var seen = {};
    Array.prototype.forEach.call(section.querySelectorAll('a[href]'), function (link) {
      var href = link.getAttribute('href');
      if (seen[href]) removeFromTabOrder(link);
      seen[href] = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   A11Y-008 — Pause control for the hero background video (WCAG 2.2.2, A)

   The hero ships two cuts, desktop and .background-video.mobile, and CSS shows
   one at a time. Both used to autoplay regardless, so every visit pulled 24 MB
   and 13 MB to watch at most one of them. This hands a source only to the cut
   that is actually on screen, measured from layout rather than a hardcoded
   breakpoint, and takes it back when the other one takes over.

   Removing the source is also what makes a poster visible: a media element
   only paints its poster while no frame has been decoded, and a decoded frame
   outranks it forever after. So the same mechanism covers three cases — the
   off-screen cut, a reduced-motion visitor, and a deliberate pause.

   The button cannot live inside .background-video, which is z-index -6 and
   would bury it. It is appended to .section-hero-banner, already position
   relative, at z-index 2 — above the video, below the sticky header, which
   creates a stacking context at 10 and would otherwise lose on DOM order.

   Reduced motion is handled here rather than in a media query because CSS
   cannot stop a <video>. A visitor who then presses play outranks it: asking
   for no motion by default should not lock anyone out of content.

   Pairs with data-src and poster on the embeds. Falls back to a plain src if
   the markup has not been switched over yet.
   -------------------------------------------------------------------------- */
(function () {
  var STYLE_ID = 'a11y-video-toggle-style';
  var STORE_KEY = 'gleezy-motion-choice';
  var MOTION_ATTR = 'data-a11y-motion';
  var MOTION_EVENT = 'gleezy:motion';

  /* Inline SVG rather than U+23F8 and U+25B6. Those code points carry emoji
     presentation on iOS and Android, so the control rendered as a colour
     emoji that ignored the button's own colour. A path owes nothing to the
     system font and inherits currentColor. */
  var ICON = {
    pause: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
           '<rect x="7" y="5" width="3.5" height="14" rx="1" fill="currentColor"/>' +
           '<rect x="13.5" y="5" width="3.5" height="14" rx="1" fill="currentColor"/></svg>',
    play:  '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
           '<path d="M8.5 5.5v13l11-6.5z" fill="currentColor"/></svg>'
  };

  var CSS =
    '.a11y-video-toggle{position:absolute;left:1.25rem;bottom:1.25rem;z-index:2;' +
    'display:flex;align-items:center;justify-content:center;width:44px;height:44px;' +
    'padding:0;border:0;border-radius:50%;background:#1A0909;' +
    'color:#FEE860;font-size:15px;line-height:1;cursor:pointer}' +
    '.a11y-video-toggle:focus-visible{outline:3px solid #FEE860;outline-offset:3px}' +
    '.a11y-video-toggle:focus:not(:focus-visible){outline:none}';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(CSS));
    document.head.appendChild(style);
  }

  /* Which of the two cuts is on screen. Read from layout rather than from a
     hardcoded 767px, so this keeps working if the breakpoint moves in Webflow. */
  function isVisible(video) {
    return !!(video.offsetWidth || video.offsetHeight);
  }

  /* The poster arrives as data-poster rather than poster, for the same reason
     the source does. A Liquid {% if %} guard in attribute position does not
     survive the Webflow embed parser — it is shredded into stray attributes —
     and an unguarded poster="" resolves against the page URL, so the browser
     fetches the HTML document as an image. A data- attribute is inert when
     empty, and this promotes it only once there is something to show. */
  function applyPoster(video) {
    var url = video.getAttribute('data-poster');
    if (url) video.setAttribute('poster', url);
    else if (video.getAttribute('poster') === '') video.removeAttribute('poster');
  }

  function sourceFor(video) {
    return video.getAttribute('data-src')
        || video.getAttribute('data-a11y-src')
        || video.getAttribute('src')
        || '';
  }

  /* Unprompted playback is allowed only while muted — the same rule that let
     the autoplay attribute work. The attribute is in the markup, but setting
     the property too costs nothing and closes the gap in browsers that honour
     only one of them. A rejection is not an error: iOS low power mode refuses,
     and the poster simply stays up. */
  function attemptPlay(video) {
    video.muted = true;
    var attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  /* Dropping the source is what makes the poster appear: a media element only
     paints its poster while no frame has been decoded. It also frees the
     download — the two cuts are 24 MB and 13 MB, and only one is ever seen. */
  function dropSource(video) {
    if (!video.getAttribute('src')) return;
    video.setAttribute('data-a11y-src', video.getAttribute('src'));
    video.setAttribute('data-a11y-time', video.currentTime || 0);
    video.pause();
    video.removeAttribute('src');
    video.load();
  }

  function giveSource(video) {
    if (video.getAttribute('src')) return attemptPlay(video);

    var url = sourceFor(video);
    if (!url) return;

    var time = parseFloat(video.getAttribute('data-a11y-time')) || 0;
    video.setAttribute('src', url);
    video.load();
    video.addEventListener('loadedmetadata', function once() {
      video.removeEventListener('loadedmetadata', once);
      if (time) { try { video.currentTime = time; } catch (e) {} }
      attemptPlay(video);
    });
  }

  function init() {
    var section = document.querySelector('.section-hero-banner');
    if (!section) return;

    var videos = section.querySelectorAll('video');
    if (!videos.length) return;

    Array.prototype.forEach.call(videos, applyPoster);

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* null until the visitor takes a side. Their choice outranks the OS
       preference in both directions — asking for no motion by default should
       not lock someone out of motion they then choose to allow. Stored so the
       choice survives navigation: a motion preference that has to be re-set on
       every page is not a preference, it is a chore. */
    var choice = null;
    try { choice = window.localStorage.getItem(STORE_KEY); } catch (e) {}
    if (choice !== 'play' && choice !== 'pause') choice = null;

    function wanted() {
      if (choice) return choice === 'play';
      return !reduce.matches;
    }

    /* The signal every other script reads. The attribute is declarative, so
       CSS can hang off it too; the event saves listeners from polling. */
    function broadcast(playing) {
      document.documentElement.setAttribute(MOTION_ATTR, playing ? 'full' : 'reduced');
      try {
        window.dispatchEvent(new CustomEvent(MOTION_EVENT, { detail: { reduced: !playing } }));
      } catch (e) {
        var legacy = document.createEvent('CustomEvent');
        legacy.initCustomEvent(MOTION_EVENT, false, false, { reduced: !playing });
        window.dispatchEvent(legacy);
      }
    }

    var injected = false;
    var button = section.querySelector('[data-video-toggle]');
    if (!button) {
      injectStyle();
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'a11y-video-toggle';
      button.innerHTML = ICON.pause;
      injected = true;
      section.appendChild(button);
    }

    function apply() {
      var playing = wanted();
      broadcast(playing);
      Array.prototype.forEach.call(videos, function (video) {
        if (playing && isVisible(video)) giveSource(video);
        else dropSource(video);
      });
      setLabel(playing);
    }

    /* The control governs every animation on the page, not just this video, so
       the name says so. Anyone who reaches it from the marquee needs to know
       that pressing it stops that too. */
    function setLabel(playing) {
      button.setAttribute('aria-label', playing
        ? 'Pause all motion on this page'
        : 'Play all motion on this page');
      if (injected) button.innerHTML = playing ? ICON.pause : ICON.play;
    }

    /* No syncing the label to whether a video happens to be playing. That was
       right when this controlled one video; it is wrong for a page-wide motion
       setting. A refused autoplay would have relabelled the control "play"
       while motion was still on and the marquee still moving — announcing the
       opposite of what pressing it does. The label tracks the preference. */

    button.addEventListener('click', function () {
      choice = wanted() ? 'pause' : 'play';
      try { window.localStorage.setItem(STORE_KEY, choice); } catch (e) {}
      apply();
    });

    if (reduce.addEventListener) reduce.addEventListener('change', apply);
    else if (reduce.addListener) reduce.addListener(apply);

    /* Orientation changes and window resizes swap which cut is on screen. */
    var pending;
    window.addEventListener('resize', function () {
      clearTimeout(pending);
      pending = setTimeout(apply, 200);
    });

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   October 2026 audit (axe-core 4.11, 42 pages)

   Each block below was checked against the live DOM before it was written;
   where the report's description and the page disagreed, the page won. The
   report's carousel finding is fixed in the A11Y-013 block above — it was a
   regression from that block, not from a theme update.
   ========================================================================== */

/* --------------------------------------------------------------------------
   Footer signup field — typed text contrast (WCAG 1.4.3, AA)

   #email-address-2 has a transparent background over the charcoal footer
   (#1A0909) and inherits #333333 for the text a visitor types: 1.52:1. The
   placeholder is a separate #999999 and already clears AA at 6.78:1, so only
   the value colour changes. Cream reads at 14.45:1.

   The product page "Shop Online / Shop In-Store" tabs dim the inactive tab
   with opacity .46 rather than a colour. #222 text at 46% over the cream body
   blends to #8a8884, about 2.6:1 — the report's "Shop In-Store" finding. At
   .72 it blends to about #585755, 5.3:1, and still reads as the inactive one.

   Both belong in the Designer: the field colour on .footer-form-field, the
   opacity on the tab's non-current state. Once they are set there, these
   rules match what the stylesheet already does and can be deleted.
   -------------------------------------------------------------------------- */
(function () {
  var STYLE_ID = 'a11y-contrast-style';

  var CSS =
    '.footer-form-field{color:#E3DED8}' +
    '.tab-link-tab-1.w-tab-link:not(.w--current){opacity:.72}';

  function init() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(CSS));
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   Site header landmark (axe "region", best practice for WCAG 1.3.1 / 2.4.1)

   The report pins this on the announcement bar alone, but two things in the
   navbar section sit outside every landmark on all 42 pages: the "Now
   available at Walmart & Target" bar and the floating "Now Available in
   Walmart" find-us button. Both live in .section_navbar beside the nav itself.

   Webflow's Navbar component ships role="banner" on .nav_component-2, so the
   banner stops short of its own section and leaves both outside it. The role
   is lifted to .section_navbar instead, which covers both with the semantics
   they actually have rather than wrapping each in its own ad hoc region. A
   banner found anywhere outside the navbar section was placed deliberately,
   so in that case nothing is touched.

   The announcement slider's own role="region" aria-label="carousel" comes
   from Webflow and nests harmlessly inside.
   -------------------------------------------------------------------------- */
(function () {
  // A <header> is only a banner when it is not scoped to a section of content.
  function isPageHeader(header) {
    return !header.closest('main, article, aside, nav, section, [role="main"]');
  }

  function init() {
    var navbar = document.querySelector('.shopify-section.section_navbar');
    if (!navbar || navbar.getAttribute('role') === 'banner') return;
    if (navbar.closest('main, [role="main"]')) return;  // a banner cannot sit in main

    var inner = [];
    var banners = document.querySelectorAll('[role="banner"]');
    for (var i = 0; i < banners.length; i++) {
      if (!navbar.contains(banners[i])) return;
      inner.push(banners[i]);
    }
    var headers = document.querySelectorAll('header');
    for (var j = 0; j < headers.length; j++) {
      if (isPageHeader(headers[j]) && !navbar.contains(headers[j])) return;
    }

    // One banner per page: the nested one gives way to the section around it.
    inner.forEach(function (el) {
      el.removeAttribute('role');
      el.setAttribute('data-a11y-banner-lifted', '');
    });
    navbar.setAttribute('role', 'banner');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   Policy pages — main landmark (axe "landmark-one-main" + "region")

   /policies/* is rendered by Shopify, not by a theme template, so there is no
   Liquid file to wrap in <main>. The content arrives as a bare
   .shopify-policy__container directly under .page-wrapper. Giving it the main
   role clears both rules on both policy pages.
   -------------------------------------------------------------------------- */
(function () {
  function init() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container || document.querySelector('main, [role="main"]')) return;
    container.setAttribute('role', 'main');
    if (!container.id) container.id = 'main-content';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   Empty headings (axe "empty-heading", WCAG 1.3.1)

   /pages/about and /pages/wholesale both end with a contact section whose
   subheading setting is blank, so the section renders <h2></h2> under "Have
   Questions?". The real fix is filling or removing that setting in the theme
   editor. Until then the empty element is taken out of the accessibility
   tree — it has nothing to say, and a heading navigator stops on it.

   Only judged at load: a merchant who fills the setting gets server-rendered
   text, which this leaves alone.
   -------------------------------------------------------------------------- */
(function () {
  function hasName(heading) {
    if (heading.textContent.trim()) return true;
    if (heading.getAttribute('aria-label') || heading.getAttribute('aria-labelledby')) return true;
    return !!heading.querySelector('img[alt]:not([alt=""]), [aria-label]');
  }

  function init() {
    var headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]');
    Array.prototype.forEach.call(headings, function (heading) {
      if (hasName(heading) || heading.getAttribute('aria-hidden') === 'true') return;
      heading.setAttribute('aria-hidden', 'true');
      heading.setAttribute('data-a11y-empty-heading', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   One level-1 heading per page (axe "page-has-heading-one", WCAG 1.3.1)

   Ten pages have none. They split two ways in the live DOM:

     A visible <h2> already titles the page — "Cart" on /cart, "Login" on
     /account/login, "Gleezy is the #1 hot dog…" on /pages/dog. That heading
     is promoted to level 1 in place, so the outline gains no duplicate.

     No suitable heading exists — /collections/shop-all and /pages/find-us
     render none at all, and /pages/wholesale opens on product-name <h3>s
     that would misname the page. A visually hidden <h1> is added at the top
     of main, named from the page title, which Shopify fills from the
     page/collection title.

   Only an <h2> is promoted. Anything deeper is a section heading, and making
   it the page heading would misdescribe the page. Like the other fallbacks,
   this retires itself: once the template ships a real <h1>, it does nothing.

   Either way, the new level-1 heading can sit directly above headings that
   now skip a level (axe "heading-order"): /pages/wholesale opens on <h3>s
   under the added <h1>, and /pages/media's promoted "Gleezy Media" is
   followed only by <h3>s. Headings between the page heading and the next
   <h2> are its top-level sections in practice, since nothing else outranks
   them, so that run is lifted until its shallowest member is level 2,
   keeping its internal nesting. The real fix is making them <h2> in the
   Designer.
   -------------------------------------------------------------------------- */
(function () {
  function pageName() {
    // Drop a " | Gleezy" or " – Gleezy Dog" style suffix if one is configured.
    return document.title.split(/\s+[|–—-]\s+/)[0].trim();
  }

  function firstVisibleHeading(main) {
    var headings = main.querySelectorAll('h2, h3, h4, h5, h6');
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      if (h.offsetParent !== null && h.textContent.trim() &&
          h.getAttribute('aria-hidden') !== 'true') return h;
    }
    return null;
  }

  // `after` is the promoted heading, or null when an <h1> was added at the top.
  function liftLeadingRun(main, after) {
    var run = [];
    var headings = Array.prototype.slice.call(main.querySelectorAll('h2, h3, h4, h5, h6'));
    var start = after ? headings.indexOf(after) + 1 : 0;
    for (var i = start; i < headings.length; i++) {
      if (headings[i].tagName === 'H2') break;
      if (headings[i].getAttribute('aria-hidden') === 'true') continue;
      run.push(headings[i]);
    }
    if (!run.length) return;

    var top = 6;
    run.forEach(function (h) { top = Math.min(top, +h.tagName.charAt(1)); });
    var shift = top - 2;
    if (shift <= 0) return;

    run.forEach(function (h) {
      h.setAttribute('role', 'heading');
      h.setAttribute('aria-level', String(+h.tagName.charAt(1) - shift));
      h.setAttribute('data-a11y-relevelled', '');
    });
  }

  function init() {
    if (document.querySelector('h1, [role="heading"][aria-level="1"]')) return;
    var main = document.querySelector('main, [role="main"]');
    if (!main) return;

    var first = firstVisibleHeading(main);
    if (first && first.tagName === 'H2') {
      first.setAttribute('role', 'heading');
      first.setAttribute('aria-level', '1');
      first.setAttribute('data-a11y-promoted', '');
      liftLeadingRun(main, first);
      return;
    }

    var name = pageName();
    if (!name) return;
    var h1 = document.createElement('h1');
    h1.className = 'form_hidden-label';
    h1.textContent = name;
    h1.setAttribute('data-a11y-page-heading', '');
    main.insertBefore(h1, main.firstChild);
    liftLeadingRun(main, null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   Embedded document titles (axe "frame-title", WCAG 4.1.2)

   Not in the report — found re-scanning the full sitemap. Six offerings and
   concept pages (/pages/offerings, /pages/retail-offerings,
   /pages/food-service-offerings, /pages/merchandise-and-collateral and two
   unlisted decks) embed an Adobe InDesign publication in .deck-embed with no
   title, so a screen reader announces "frame" with nothing to say what is in
   it. Each page is about its deck, so the page title names it.

   Better set as title="…" on the iframe in each embed's code. Once it is,
   this leaves that iframe alone.
   -------------------------------------------------------------------------- */
(function () {
  function pageName() {
    return document.title.split(/\s+[|–—-]\s+/)[0].trim();
  }

  function init() {
    var frames = document.querySelectorAll('.deck-embed iframe, iframe[src*="indd.adobe.com"]');
    Array.prototype.forEach.call(frames, function (frame) {
      if ((frame.getAttribute('title') || '').trim()) return;
      if (frame.getAttribute('aria-label') || frame.getAttribute('aria-labelledby')) return;
      var name = pageName();
      frame.setAttribute('title', name ? name + ' (interactive document)' : 'Interactive document');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
